/**
 * Converts an unknown input to a finite number.
 * Returns `null` when the value cannot be parsed safely.
 */
export function parseNumeric(value: unknown): number | null {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
